import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export default function AssignFarmerModal({
  open,
  accountName = "",
  farmers = [],
  onClose,
  onSubmit,          // should return a Promise
  isSubmitting = false,
}) {
  const [farmerId, setFarmerId] = useState("");

  useEffect(() => {
    if (open) setFarmerId(""); // reset when reopened
  }, [open]);

  if (!open) return null;

  const handleSubmit = async () => {
    if (!farmerId || isSubmitting) return;
    
    try {
      await onSubmit?.(parseInt(farmerId, 10));
      // Modal will be closed by parent component after successful assignment
    } catch (err) {
      console.error("Failed to assign farmer:", err);
      toast.error(err.message || 'Failed to assign farmer');
    }
  };

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget && !isSubmitting) onClose?.();
      }}
    >
      {/* backdrop */}
      <div className="absolute inset-0 bg-black/30" />

      {/* card */}
      <div className="relative w-full max-w-xl rounded-2xl bg-white shadow-xl">
        <div className="p-6">
          <h2 className="text-2xl font-extrabold tracking-tight">Assign Farmer</h2>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">Account Name</label>
              <input
                value={accountName}
                readOnly
                className="h-10 rounded-lg border border-slate-300 bg-slate-100 px-3 text-sm font-semibold"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-xs font-medium text-gray-500 mb-1">Farmer</label>
              <select
                className="h-10 rounded-lg border border-slate-300 px-3 text-sm"
                value={farmerId}
                onChange={(e) => setFarmerId(e.target.value)}
                disabled={isSubmitting}
              >
                <option value="">Select Farmer</option>
                {farmers.map((f) => (
                  <option key={f.id} value={f.id}>
                    {f.username}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mt-8 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="rounded-full border px-5 py-2 text-sm font-medium hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={!farmerId || isSubmitting}
              className="rounded-full bg-yellow-200 px-5 py-2 text-sm font-semibold text-black hover:bg-yellow-300 disabled:bg-slate-400 disabled:cursor-not-allowed disabled:text-gray-600"
            >
              {isSubmitting ? (
                <span className="flex items-center">
                  <span className="animate-spin inline-block w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full mr-2"></span>
                  Submitting…
                </span>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}